import React, { cloneElement, isValidElement } from 'react';
// import { useDispatch } from 'react-redux';
import makeStyles from '@material-ui/core/styles/makeStyles';
import List from '@material-ui/core/List';
import Box from '@material-ui/core/Box';
import { NavLink } from 'react-router-dom';
import clsx from 'clsx';
import { alpha } from '@material-ui/core/styles';
import { SIDEBAR_CONSTANTS } from '../../CmtLayouts/Vertical/constants/sidebar';
// import { setKeyword } from '../../../redux/actions/Search';

const useStyles = makeStyles(theme => ({
  navMenuItem: {
    padding: '12px 0 12px 0',
    position: 'relative',
    '.Cmt-miniLayout .Cmt-sidebar-content:not(:hover) &': {
      // paddingLeft: 16,
    },
  },
  navMenuLink: {
    display: 'flex',
    flexDirection: "row",
    alignItems: 'center',
    padding: '9px 16px',
    color: SIDEBAR_CONSTANTS.COLORS.DEFAULT_TEXT,
    whiteSpace: "nowrap",
    '&:hover, &:focus': {
      color: SIDEBAR_CONSTANTS.COLORS.ACTIVE_TEXT,
    },
    '&.active': {
      color: SIDEBAR_CONSTANTS.COLORS.ACTIVE_TEXT,
      backgroundColor: SIDEBAR_CONSTANTS.COLORS.ACTIVE_BACKGROUND,
      '& .Cmt-icon-root, & .Cmt-nav-text': {
        color: SIDEBAR_CONSTANTS.COLORS.ACTIVE_TEXT,
      },
      '&:hover, &:focus': {
        '& .Cmt-nav-text, & .Cmt-icon-root': {
          color: SIDEBAR_CONSTANTS.COLORS.ACTIVE_TEXT,
        },
      },
    },
    '.Cmt-miniLayout .Cmt-sidebar-content:not(:hover) &': {
      // justifyContent: 'center',
      // padding: 0,
      // height: 40,
      // width: 40,
      // borderRadius: '50%',
      // marginLeft: 4,
      // marginRight: 4,
    },
  },
  navText: {
    flex: 1,
    fontSize: 14,
    padding: "0 8px",
    whiteSpace: "break-spaces",
    textAlign: "left",
    '.Cmt-miniLayout .Cmt-sidebar-content:not(:hover) &': {
      // display: 'none',
    },
  },
  iconRoot: {
    marginRight: 8,
    fontSize: 24,
    '.Cmt-miniLayout .Cmt-sidebar-content:not(:hover) &': {
      marginRight: 0,
    },
  },
}));

const NavMenuItem = props => {
  const { name, icon, link } = props;
  const classes = useStyles();
  // const dispatch = useDispatch();

  const renderIcon = () => {
    if (icon && isValidElement(icon)) {
      return cloneElement(icon, {
        className: clsx(classes.iconRoot, 'Cmt-icon-root'),
      });
    }

    return null;
  };

  return (
    <List
      component="div"
      className={clsx(classes.navMenuItem, 'Cmt-nav-menu-item')}
    >
      {props.disabled ? (
        <Box
          className={clsx(classes.navMenuLink, 'Cmt-nav-menu-link')}
          style={{
            color: '#bdbdbd',
            backgroundColor: '#f5f5f5',
            cursor: 'not-allowed',
            pointerEvents: 'none',
          }}
        >
          {renderIcon()}
          <Box component="span" className={clsx(classes.navText, 'Cmt-nav-text')}>
            {name}
          </Box>
        </Box>
      ) : (
      <NavLink className={clsx(classes.navMenuLink, 'Cmt-nav-menu-link')} to={link}>
        {renderIcon()}
        <Box component="span" className={clsx(classes.navText, 'Cmt-nav-text')}>
          {name}
        </Box>
      </NavLink>
      )}
    </List>
  );
};

export default NavMenuItem;
